import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import Icon from 'components/common/Icon/Icon'

const Gallery = ({
  compatibilityStatus: {
    compatibilityType
  } = {},
  imageSetPath
}) =>
  <Wrapper>
    <BadgeImage
      hidden={ compatibilityType !== 'Compatible' }
      asset="product-badge"
      width={ 80 }
      height={ 98 }
      alt="product-badge" />
    <GalleryIframe title="Tire Line Image Gallery" src={ imageSetPath } />
  </Wrapper>

Gallery.propTypes = {
  compatibilityStatus: PropTypes.shape({
    compatibilityType: PropTypes.bool
  }),
  imageSetPath: PropTypes.string
}

export default Gallery

const Wrapper = styled.div`
  position: relative;
  overflow: hidden;
`

const GalleryIframe = styled.iframe`
  min-width: 100%;
  width: 100%;
  height: 570px;
  border: none;
`

const BadgeImage = styled(Icon)`
  position: absolute;
  top: 0;
  left: 0;
`
